"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildingVisitTracker = void 0;
var StorageApi_1 = require("@/api/browser/StorageApi");
var BUILDING_TRACKER_KEY = 'buildingTracker';
exports.BuildingVisitTracker = {
    log: function (id) {
        var trailStr = StorageApi_1.readLocalStorage(BUILDING_TRACKER_KEY);
        var trail = [];
        if (trailStr) {
            trail = JSON.parse(trailStr);
        }
        if (trail.length > 100) {
            trail.shift();
        }
        var date = new Date().getTime();
        trail.push({ id: id, date: date });
        StorageApi_1.setLocalStorage(BUILDING_TRACKER_KEY, JSON.stringify(trail));
    },
    getRecentVisitCount: function (id) {
        var RECENT_DAY = 2;
        var DAYS = 24 * 60 * 60 * 1000;
        var trailStr = StorageApi_1.readLocalStorage(BUILDING_TRACKER_KEY);
        var trail = [];
        if (trailStr) {
            trail = JSON.parse(trailStr);
        }
        if (trail.length > 100) {
            trail.shift();
        }
        var recentVisits = trail.filter(function (it) { return it.id === id; })
            .filter(function (it) { return it.date + RECENT_DAY * DAYS > new Date().getTime(); });
        return recentVisits.length;
    },
};
